import { ContactMatch, ContactSearchResult } from 'nekst-api';
import React, { useEffect } from 'react';
import {
  BaseInputProps,
  LoadingAnimation,
  RadioButtonOption,
  RadioButtonsGroup, TextLink,
} from 'ui-builder';

export interface SearchResultsRadioButtonsGroupProps extends BaseInputProps {
  searchResults?: ContactSearchResult[] | null;
}

function getDescriptionForItem(matches: ContactMatch[]): string {
  return 'The contact was found by: ' + matches.map((match) => {
    switch (match) {
      case ContactMatch.NAME:
        return 'name';
      case ContactMatch.EMAIL:
        return 'email';
      case ContactMatch.PHONE_NUMBER:
        return 'phone number';
      default:
        return match;
    }
  })
    .join('; ');
}

export function SearchResultsRadioButtonsGroup(props: SearchResultsRadioButtonsGroupProps) {

  const searchResults = props.searchResults || null;
  const [options, setOptions] = React.useState<RadioButtonOption[]>([]);

  useEffect(() => {
    let result: RadioButtonOption[] = [];

    if (searchResults && searchResults.length > 0) {
      result = searchResults.map((item) => ({
        label: item.name.fullName,
        value: item.externalLinks![0].externalContactId,
        description: (<>
          {getDescriptionForItem(item.matches)}
          {'. '}
          FUB contact:
          {' '}
          <TextLink href={item.externalLinks![0]._externalProfileUrl} target="_blank">
            {item.name.fullName}
          </TextLink>
          .
        </>)
      })) as RadioButtonOption[];
    }

    result.push(({
      label: 'Create New Follow Up Boss Contact',
      value: '',
      description: 'Follow Up Boss will run deduplication process and link to existing contact in its database (if it\'s found), otherwise a new contact entry will be created'
    }));

    setOptions(result);

    props.onChangeCallback?.({
      selectedOption: result[0].value,
    });
  }, [searchResults?.length]);

  if (searchResults) {
    return (
      <RadioButtonsGroup
        {...props}
        options={options}
      />
    );
  } else {
    return (<LoadingAnimation />);
  }
}
